import { routingConfig } from '@makemydeal/dr-sales-checkin-types';
import type { HostActions } from '@makemydeal/dr-activities-vehicle-details';
import { navigateTo } from '@makemydeal/dr-activities-common';

export const hostActions: HostActions = {
    startTestDrive: (vin: string, stockNumber?: string) => {
        // TODO: Implement test drive start logic
        console.log('Start test drive for VIN:', vin, 'Stock Number:', stockNumber);
    },
    switchVehicle: () => navigateTo(routingConfig.INVENTORY)
};
